import Form from "./Form";
import ConcentricLoader from "@hudson/ui/components/Loader/ConcentricLoader";
import Session from "@lib/session";
import { useUserProfileQuery } from "@graphql/api";

function dropTypename(object) {
  if (object?.__typename) {
    delete object.__typename;
  }
  return object;
}

export default function Profile() {
  const {
    data: profileData,
    loading: profileLoading,
    error,
  } = useUserProfileQuery({
    variables: { id: Session.getBooking().profiles.user },
  });

  if (error) {
    console.error(error);
    return null;
  }

  return profileLoading ? (
    <ConcentricLoader className="opacity-60 max-w-2xl mx-auto px-4 sm:py-10 sm:px-6 lg:px-8" />
  ) : (
    <Form profile={dropTypename({ ...profileData?.userProfile?.contactInfo })} />
  );
}
